import { appendStyles, CLIENT_ID_NAMESPACE, HCR_VERSION_SUFFIX } from '../packages/injecss/injecss.js';

function appendHelpersStyles(helpersName, styles) {
  appendStyles("".concat(helpersName, "Helpers__").concat(CLIENT_ID_NAMESPACE).concat(HCR_VERSION_SUFFIX), styles.raw);
}

export { appendHelpersStyles };
